import { AllMetricsInsight } from "@/components/all-metrics-insight/AllMetricsInsight";

const AllMetricsInsightPage = () => <AllMetricsInsight />;

export default AllMetricsInsightPage;
